import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useCourseQuery = (id) =>
  useQuery({
    queryKey: ['courses', id],
    queryFn: async () => {
      const { data } = await adminApi.getCourse(id)
      return data.data
    }
  })
